var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "project-container-wrapper" }, [
    _c("div", { staticClass: "project-container clearfix" }, [
      _c(
        "h4",
        [
          _c("HKLLeftRight", {
            scopedSlots: _vm._u(
              [
                {
                  key: "left",
                  fn: function () {
                    return [
                      _c("span", [
                        _vm._v(_vm._s(_vm.$t("project.tableTitle"))),
                      ]),
                      _vm._v(" "),
                      _c("i", {
                        staticClass: "fa fa-refresh dark flat icon_refresh",
                        on: {
                          click: function () {
                            return _vm.loadProjectTable()
                          },
                        },
                      }),
                    ]
                  },
                  proxy: true,
                },
                _vm.isHKlandUser
                  ? {
                      key: "right",
                      fn: function () {
                        return [
                          _c("HKLButton", {
                            staticClass: "btn-reset",
                            attrs: { action: "resetFilter", color: "darkblue" },
                            on: {
                              click: function () {
                                return _vm.resetFilterObject()
                              },
                            },
                          }),
                        ]
                      },
                      proxy: true,
                    }
                  : null,
              ],
              null,
              true
            ),
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "project-table" },
        [
          [
            _c("table", { staticClass: "hover" }, [
              _c("thead", [
                _c(
                  "tr",
                  _vm._l(_vm.itemHeaders, function (header, index) {
                    return _c(
                      "th",
                      {
                        key: index,
                        class: header.class,
                        on: {
                          click: function () {
                            return _vm.sortBy(header.code, header.rank)
                          },
                        },
                      },
                      [
                        _vm._v(
                          "\n                " +
                            _vm._s(header.name) +
                            " " +
                            _vm._s(
                              _vm.orderbyAttr === header.code
                                ? _vm.reverse
                                  ? "▼"
                                  : "▲"
                                : null
                            ) +
                            "\n              "
                        ),
                      ]
                    )
                  }),
                  0
                ),
                _vm._v(" "),
                _vm.isHKlandUser
                  ? _c(
                      "tr",
                      _vm._l(_vm.itemHeaders, function (header) {
                        return _c(
                          "th",
                          { key: header.code },
                          [
                            _c(
                              header.filterComponent,
                              _vm._b(
                                {
                                  tag: "component",
                                  model: {
                                    value: _vm.filterObject[header.code],
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.filterObject,
                                        header.code,
                                        $$v
                                      )
                                    },
                                    expression: "filterObject[header.code]",
                                  },
                                },
                                "component",
                                header.filterComponentAttrs || {},
                                false
                              )
                            ),
                          ],
                          1
                        )
                      }),
                      0
                    )
                  : _vm._e(),
              ]),
              _vm._v(" "),
              _c(
                "tbody",
                _vm._l(_vm.orderedItems, function (item, index) {
                  return _c("tr", { key: index }, [
                    _c("td", [
                      _c("div", [
                        _c(
                          "a",
                          {
                            staticClass: "link_text",
                            class: {
                              bold_text: item.isPending,
                              text_red: item.highlightNumber,
                            },
                            on: {
                              click: function () {
                                return _vm.navToDetailPG(item)
                              },
                            },
                          },
                          [
                            _vm._v(
                              "\n                    " +
                                _vm._s(item.number) +
                                "\n                  "
                            ),
                          ]
                        ),
                      ]),
                    ]),
                    _vm._v(" "),
                    _c("td", [
                      _c(
                        "a",
                        {
                          staticClass: "link_text",
                          class: { bold_text: item.isPending },
                          on: {
                            click: function () {
                              return _vm.navToDetailPG(item)
                            },
                          },
                        },
                        [
                          _vm._v(
                            "\n                  " +
                              _vm._s(item.description) +
                              "\n                "
                          ),
                        ]
                      ),
                      _vm._v(" "),
                      item.showDocIcon
                        ? _c("div", { staticClass: "new-doc" }, [
                            _vm._v(
                              "\n                  " +
                                _vm._s(_vm.$t("tenantProjects.docs")) +
                                "\n                "
                            ),
                          ])
                        : _vm._e(),
                    ]),
                    _vm._v(" "),
                    _c(
                      "td",
                      {
                        staticClass: "number_text",
                        class: { bold_text: item.isPending },
                      },
                      [
                        _c("span", [_vm._v(_vm._s(item.status))]),
                        _vm._v(" "),
                        item.isPending
                          ? _c("div", { staticClass: "orange_bubble" }, [
                              _c("i", {
                                staticClass: "fa fa-thumb-tack",
                                attrs: { "aria-hidden": "true" },
                              }),
                            ])
                          : _vm._e(),
                      ]
                    ),
                    _vm._v(" "),
                    _c("td", { class: { bold_text: item.isPending } }, [
                      _vm._v(
                        "\n                " +
                          _vm._s(item.completion) +
                          "\n              "
                      ),
                    ]),
                    _vm._v(" "),
                    _c(
                      "td",
                      {
                        staticClass: "number_text",
                        class: { bold_text: item.isPending },
                      },
                      [
                        _vm._v(
                          "\n                " +
                            _vm._s(item.vendor) +
                            "\n              "
                        ),
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "td",
                      {
                        staticClass: "number_text",
                        class: { bold_text: item.isPending },
                      },
                      [
                        _vm._v(
                          "\n                " +
                            _vm._s(item.amount) +
                            "\n              "
                        ),
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "td",
                      {
                        staticClass: "number_text currency_text",
                        class: { bold_text: item.isPending },
                      },
                      [
                        _vm._v(
                          "\n                " +
                            _vm._s(item.currencyCode) +
                            "\n              "
                        ),
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "td",
                      {
                        staticClass: "number_text",
                        class: { bold_text: item.isPending },
                      },
                      [
                        _vm._v(
                          "\n                " +
                            _vm._s(
                              item.managedBy === _vm.currentUser.id
                                ? _vm.$t("yes")
                                : _vm.$t("no")
                            ) +
                            "\n              "
                        ),
                      ]
                    ),
                  ])
                }),
                0
              ),
            ]),
          ],
        ],
        2
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "nav_line" },
        [
          _vm.showCreateButton()
            ? _c("CreateProject", { staticClass: "nav_button" })
            : _vm._e(),
          _vm._v(" "),
          _c(
            "button",
            {
              staticClass: "nav_button btn btn--darkblue",
              attrs: { type: "button" },
              on: {
                click: function () {
                  return _vm.navToAllProjects()
                },
              },
            },
            [_vm._v(_vm._s(_vm.$t("action.viewAllProjects")))]
          ),
        ],
        1
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }